export default __webpack_public_path__ + "632973cc6b6de879cf6e7dfe5d7a4549.png";